import { hexToRgbArray } from '../../Utils';

export const getLinkTileBgColor = (hex: string) => {
  const rgbArray = hexToRgbArray(hex);
  return `rgb(${rgbArray[0]} ${rgbArray[1]} ${rgbArray[2]} / 40%)`;
};
